import type {
  AccountSummary,
  ApprovedPredictionSymbol,
  FinanceTx,
  Position,
  SymbolQuote,
  TradeHistoryItem,
  TradingAccount,
} from './types'

/** Visual-checkpoint fixtures only — never treated as live execution. Never use outside ?fixtures=1. */
export const fixtureAccount: TradingAccount = {
  id: 1,
  mt5Login: 90123456,
  server: 'iBullCapital-Demo',
  mode: 'DEMO',
  currency: 'USD',
  balance: 1020,
  equity: 1014.5,
  status: 'ACTIVE',
  createdAt: '2026-08-01T10:00:00Z',
  updatedAt: '2026-08-06T08:00:00Z',
}

/** Fixture Live account for Live-create success UX review only (`?fixtures=1`). */
export const fixtureLiveAccount: TradingAccount = {
  id: 2,
  mt5Login: 80123456,
  server: 'iBullCapital-Live',
  mode: 'LIVE',
  currency: 'USD',
  balance: 0,
  equity: 0,
  status: 'ACTIVE',
  createdAt: '2026-08-07T08:00:00Z',
  updatedAt: '2026-08-07T08:00:00Z',
}

export const fixtureSummary: AccountSummary = {
  id: 1,
  mt5_login: 90123456,
  server: 'iBullCapital-Demo',
  mode: 'DEMO',
  currency: 'USD',
  balance: 1020,
  equity: 1014.5,
  floating_profit: -5.5,
  status: 'ACTIVE',
  sync_state: 'LIVE',
  last_sync_at: new Date().toISOString(),
}

/** Portal Active Predictions may only show approved PREDGOLD_* symbols. */
export const fixturePositions: Position[] = [
  {
    ticket: 10001,
    symbol: 'PREDGOLD_BAL',
    side: 'BUY',
    volume: 0.01,
    open_price: 2345.2,
    current_price: 2342.1,
    floating_profit: -3.1,
  },
]

export const fixtureTrades: TradeHistoryItem[] = [
  {
    ticket: 9901,
    symbol: 'PREDGOLD_SAFE',
    side: 'SELL',
    volume: 0.01,
    profit: 12.4,
    net_profit: 12.1,
    close_time: '2026-08-05T16:22:00Z',
  },
]

/** Fixture quotes for visual review of Open Prediction — not live MT5. */
export const fixtureQuotes: Record<ApprovedPredictionSymbol, SymbolQuote> = {
  PREDGOLD_SAFE: {
    symbol: 'PREDGOLD_SAFE',
    bid: 2341.1,
    ask: 2341.4,
    last: 2341.25,
    spread: 0.3,
    quoteTimestamp: '2026-08-06T08:00:00Z',
    tradeEnabled: false,
    marketStatus: 'OPEN',
    syncState: 'FIXTURE_REVIEW_ONLY',
  },
  PREDGOLD_BAL: {
    symbol: 'PREDGOLD_BAL',
    bid: 2341.2,
    ask: 2341.55,
    last: 2341.35,
    spread: 0.35,
    quoteTimestamp: '2026-08-06T08:00:00Z',
    tradeEnabled: false,
    marketStatus: 'OPEN',
    syncState: 'FIXTURE_REVIEW_ONLY',
  },
  PREDGOLD_AGG: {
    symbol: 'PREDGOLD_AGG',
    bid: 2341.0,
    ask: 2341.5,
    last: 2341.2,
    spread: 0.5,
    quoteTimestamp: '2026-08-06T08:00:00Z',
    tradeEnabled: false,
    marketStatus: 'OPEN',
    syncState: 'FIXTURE_REVIEW_ONLY',
  },
}

/** Demo fixtures: no finance funding rows (Demo opening balance is not a deposit). */
export const fixtureTx: FinanceTx[] = []

export function useFixturesFromQuery() {
  if (typeof window === 'undefined') return false
  return new URLSearchParams(window.location.search).get('fixtures') === '1'
}
